import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class Background {
    constructor(component) {
        if (component == null) return;

        this.init(component);
    }

    init(component) {
        const backgroundVideo = component.querySelector('.c-background__video');

        if (backgroundVideo) {
            this.loadBackgroundVideo(component, backgroundVideo);
        }
    }

    loadBackgroundVideo(component, backgroundVideo) {
        const poster = backgroundVideo.querySelector('img');
        const video = backgroundVideo.querySelector('video');
        const sources = video.querySelectorAll('source');

        sources.forEach((source) => {
            ScrollTrigger.matchMedia({
                '(max-width: 959px)': function () {
                    poster.classList.remove('is-hidden');
                    source.setAttribute('src', '');
                    video.load();
                },
                '(min-width: 960px)': function () {
                    if (source.dataset.src != undefined) {
                        source.setAttribute('src', source.dataset.src);

                        video.load();

                        video.currentTime = 0.01;

                        video.addEventListener('loadedmetadata', function () {
                            poster.width = video.videoWidth;
                            poster.height = video.videoHeight;
                        });

                        video.addEventListener('canplaythrough', function () {
                            poster.classList.add('is-hidden');

                            ScrollTrigger.create({
                                trigger: component,
                                onEnter: function () {
                                    video.play();
                                },
                                onLeave: function () {
                                    video.pause();
                                },
                                onEnterBack: function () {
                                    video.play();
                                },
                                onLeaveBack: function () {
                                    video.pause();
                                },
                            });
                        });
                    }
                },
            });
        });
    }
}

export default Background;
